import { connect } from "react-redux";
import { compose } from "recompose";
import { signUp } from "actions/auth/authActions";
import SignUpForm from "components/SignUp/SignUpForm";
import { withFirebase } from "react-redux-firebase";

const mapStateToProps = ({ firebase }) => {
  return {
    isAuthenticated: !!firebase.auth && !!firebase.auth.uid,
    auth: firebase.auth,
    authError: firebase.authError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signUpAction: credentials => dispatch(signUp(credentials)),
  };
};

export default compose(
  withFirebase,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SignUpForm);
